
/**
 * Custom component for Bimini two column menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <biminiTwoColumnSection> adds a two column layout for Bimini menu sections.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <biminiTwoColumnSection>.
 *    - Add "menuItemComponent" prop <biminiTwoColumnSection>.
 */

import {defineComponent, PropType} from "vue";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'Bimini_twoColumnSection',
  components: {BiminiDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
